export default __webpack_public_path__ + "static/media/book.3ba359ae.svg";